import { createContext, useContext, type FC, type ReactNode } from 'react'
import { type IdleManagerStore } from 'entities/Auth/ui/IdleManager/store/IdleManagerStore'

export const IdleManagerContext = createContext<IdleManagerStore | null>(null)

export const useIdleManagerContext = () => {
  const context = useContext(IdleManagerContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with IdleManagerContext')

  return context
}

type IProviderIdleManagerProps = {
  value: IdleManagerStore
  children: ReactNode
}

export const ProviderIdleManager: FC<IProviderIdleManagerProps> = ({ value, children }) => {
  return <IdleManagerContext.Provider value={value}>{children}</IdleManagerContext.Provider>
}
